import styled from 'styled-components';
import { FlexAlignCenter, FlexCenterBoth } from 'components/primitives/flex';

export default function ProtectInfoMessage() {
  return (
    <FlexAlignCenter gap="28px" width="85%" mt="6px" mb="42px">
      <LockIconWrapper>
        <LockIcon color="#083170" />
      </LockIconWrapper>
      <p>To protect your payment and insurance coverage, always communicate and pay through the Boatsetter platform.</p>
    </FlexAlignCenter>
  );
}

const LockIcon = ({ color = '#8E9697' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
    <path
      fill={color}
      d="M14.63 7.41V4.8c0-2.64-2.15-4.8-4.8-4.8h-.56c-2.64 0-4.8 2.15-4.8 4.8v2.61C3.07 7.62 2 8.82 2 10.28v6.69c0 1.6 1.31 2.91 2.91 2.91h9.28c1.6 0 2.91-1.31 2.91-2.91v-6.69c0-1.46-1.08-2.66-2.47-2.87zm.97 9.56c0 .78-.63 1.41-1.41 1.41H4.91c-.78 0-1.41-.63-1.41-1.41v-6.69c0-.78.63-1.41 1.41-1.41h9.28c.78 0 1.41.63 1.41 1.41v6.69zM13.13 4.8v2.57H5.98V4.8c0-1.82 1.48-3.3 3.3-3.3h.56c1.81 0 3.29 1.48 3.29 3.3zm-2.16 8.82c0 .78-.64 1.42-1.42 1.42-.78 0-1.42-.64-1.42-1.42 0-.78.64-1.42 1.42-1.42.78 0 1.42.64 1.42 1.42z"
    />
  </svg>
);

const LockIconWrapper = styled(FlexCenterBoth)`
  border-radius: 50%;
  background: #72d4ba;
  width: 48px;
  height: 48px;
  flex: 0 0 48px;
  path {
    fill: #083170;
  }
`;
